export default class Copyright {
  constructor($el, config = {}) {
    this.$el = $el;
    this.id = $el.getAttribute('id');
    this.config = {
      baseClass: 'copyright',
      panelClass: 'copyright__panel',
      closeButtonClass: 'copyright__panel-close',
      openButtonClass: 'copyright__panel-open',
      mustOpen: false,
      openOnHoverTimeout: 500,
      ...config,
    };

    this.init();
  }

  init() {
    this.$open = this.$el.querySelector(`.${this.config.openButtonClass}`);
    this.$close = this.$el.querySelector(`.${this.config.closeButtonClass}`);
    this.$panel = this.$el.querySelector(`.${this.config.panelClass}`);

    this.panelOpenBinded = this.panelOpen.bind(this);
    this.panelCloseBinded = this.panelClose.bind(this);
    this.outsideClickBinded = this.outsideClick.bind(this);
    this.keyDownBinded = this.keyDown.bind(this);

    this.$open.addEventListener('click', this.panelOpenBinded);
    this.$open.addEventListener('mouseenter', this.mouseEnter.bind(this));
    this.$open.addEventListener('mouseleave', this.mouseLeave.bind(this));
    this.$close.addEventListener('click', this.panelCloseBinded);
    window.addEventListener('click', this.outsideClickBinded);
    window.addEventListener('keydown', this.keyDownBinded);
  }

  panelOpen() {
    this.$open.setAttribute('aria-expanded', 'true');
    this.$panel.classList.add(`${this.config.panelClass}--open`);
    this.$close.setAttribute('aria-expanded', 'true');
  }

  panelClose() {
    this.$open.setAttribute('aria-expanded', 'false');
    this.$panel.classList.remove(`${this.config.panelClass}--open`);
    this.$close.setAttribute('aria-expanded', 'false');
  }

  mouseEnter() {
    this.config.mustOpen = true;

    setTimeout(() => {
      if (this.config.mustOpen) {
        this.panelOpen();
      }
    }, this.config.openOnHoverTimeout);
  }

  mouseLeave() {
    this.config.mustOpen = false;
  }

  outsideClick(event) {
    if (!event.target.closest(`#${this.id}`)) {
      this.panelClose();
    }
  }

  keyDown(event) {
    if (event.key === 'Escape') {
      this.panelCloseBinded();
    }
  }
}

document.querySelectorAll('.js-copyright').forEach(
  $copyright => new Copyright($copyright),
);
